import { isValidIconElement, Slot } from '@farol-ds/react'
import classNames from 'classnames'
import { cloneElement, HTMLAttributes } from 'react'

import styles from './list-block.module.scss'

export type ListBlockTrailingElement = HTMLSpanElement

export type ListBlockTrailingProps = HTMLAttributes<ListBlockTrailingElement> & {
  asChild?: boolean
}

function ListBlockTrailing(props: ListBlockTrailingProps) {
  const { children, className, asChild, ...rest } = props
  const classes = classNames(styles.trailing, className)

  const Component = asChild ? Slot : 'span'

  return (
    <Component className={classes} {...rest}>
      {isValidIconElement(children) ? cloneElement(children, { size: 'sm' }) : children}
    </Component>
  )
}

export default ListBlockTrailing
